<template>
  <cargo-ag-grid
    class="intelligent-booking-table"
    :grid-params.sync="gridParams"
    :grid-options="gridOptions"
    :column-defs="columnDefs"
    :show-side-bar="true"
    config-module="310101"
    :row-data="rowData"
  />
</template>

<script>
import UploadStatus from './UploadStatus'
import OperationRender from './OperationRender'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { removeIntelligentDocument } from '@/api/seaExport/intelligentBooking'
import URL from '@/api/urlTranslator'

export default {
  name: 'IntelligentBookingTable',
  props: {
    rowData: {
      type: Array, default: () => []
    },
    tabType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      gridParams: {},
      gridOptions: {
        suppressContextMenu: true
      },
      storageURL: ''
    }
  },
  computed: {
    columnDefs() {
      // const { storageURL } = this
      return [
        { headerName: this.$t('SeaExport.SerialNo'), colId: 'fileNo', field: 'fileNo', width: 100 },
        { headerName: this.$t('FileHistory.fileName'), colId: 'fileName', field: 'fileName', cellRenderer: (params) => {
          const url = `${URL.common.findByFileId}/${params.data.fileId}?sessionId=${this.$store.getters.token}`
          return `<a href="${url}" target="_blank" style="color:#1890ff">${params.value}</a>`
        }, width: 380
        },
        {
          headerName: this.$t('FileHistory.fileSize'), colId: 'fileSize', field: 'fileSize',
          cellRenderer: (params) => {
            return ColumnUtils.fileSizeLabelFun(params.value)
          }, width: 120
        },
        { headerName: this.$t('Partners.UploadTime'), colId: 'dateCreated', field: 'dateCreated' },
        {
          headerName: this.$t('SeaExport.ResolutionCompletionTime'),
          colId: 'analysisCompleteDate',
          field: 'analysisCompleteDate'
        },
        { headerName: this.$t('FileHistory.jobType'), colId: 'fileType', field: 'fileType', width: 120 },
        {
          headerName: this.$t('SeaExport.Source'), colId: 'source', field: 'source', width: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.intelligentDocumentSourceLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.UploadProgress'), colId: 'status', field: 'status',
          cellRendererFramework: UploadStatus, width: 120
        },
        {
          headerName: this.$t('FileHistory.operation'), colId: 'operations', field: 'operations',
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('SeaExport.ViewParsingResults'),
                type: 'primary',
                onClick: (params) => {
                  this.$emit('showDetails', { from: this.tabType, params })
                },
                visible: (params) => params.status === 2 || params.status === 3
              }, {
                title: this.$t('SeaExport.ViewOrder'),
                type: 'primary',
                onClick: (params) => {
                  console.log('查看订单', params)
                  this.$router.push({ name: 'SeaBooking', query: { jobNo: params.jobNo }})
                },
                visible: (params) => params.status === 3
              }, {
                title: this.$t('FileHistory.Delete'),
                type: 'danger',
                onClick: (params) => this.handleDelete(params.uuid),
                visible: (params) => params.status === 0 || params.status === 1 || params.status === 2
              }
            ]
          }
        }
      ]
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
    },
    handleDelete(uuid) {
      this.$confirm(this.$t('SeaExport.AreYouWantToDelete'), this.$t('SeaExport.Tips'), {}).then(() => {
        removeIntelligentDocument(uuid).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.$emit('refresh')
        })
      })
    }
  }
}
</script>

<style>
.intelligent-booking-table {
  height: 100%;
}

</style>
